exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".swiper{width:100%;height:100%;overflow:hidden}.swiper .swiper-item{height:100%;background-position:50%;background-size:cover;position:relative;overflow:hidden;float:left}.swiper .swiper-item.swiper-item-active .animated{-webkit-animation-fill-mode:both;animation-fill-mode:both;opacity:1}.swiper .swiper-item:not(.active) .animated{-webkit-animation:none;animation:none;opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/sass-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/swiper/Swiper.vue
// module id = 173
// module chunks = 0